import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation, useParams } from 'react-router-dom';
import qs from 'query-string';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useB2cStudentDetail = (id: number, group: string) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [studentInfo, setStudentInfo] = useState<StudentInfoDto>();
  
  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { refetch } = useQuery(
    [endpoints.b2c.student.info, [id, group]],
    () =>
      fetcher.b2c.postStudentInfo({
        id: id,   
        group: group,     
      }),
    {
      enabled: (id > 0 && !!group),      
      onSuccess: (res: StudentDtailResDto) => {
        switch (res.code) {
          case 200:
            setStudentInfo(res.result?.info);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: studentInsert, isSuccess: insertSuccess } = useMutation(
    [endpoints.b2c.student.add],
    fetcher.b2c.postStudentInsert,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            refetch();
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: studentUpdate, isSuccess: updateSuccess } = useMutation(
    [endpoints.b2c.student.update],
    fetcher.b2c.postStudentUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            refetch();
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )   
  
  const { mutate: studentDelete, isSuccess: deleteSuccess } = useMutation(
    [endpoints.b2c.student.delete],
    fetcher.b2c.postStudentDelete,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            refetch();
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )   
  
  const { mutate: studentRestore, isSuccess: restoreSuccess } = useMutation(
    [endpoints.b2c.student.restore],
    fetcher.b2c.postStudentRestore,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            refetch();
            message.info(MSG.SUCCESS_RESTORE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )   

  const { mutate: appmInsert, isSuccess: insertSuccessAppm } = useMutation(
    [endpoints.b2c.seminar.student.add],
    fetcher.b2c.postSeminarStudentInsert,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            refetch();
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: appmUpdate, isSuccess: updateSuccessAppm } = useMutation(
    [endpoints.b2c.seminar.student.update],
    fetcher.b2c.postSeminarStudentUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            refetch();
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )   

  const { mutate: appmDelete, isSuccess: deleteSuccessAppm } = useMutation(
    [endpoints.b2c.seminar.student.delete],
    fetcher.b2c.postSeminarStudentDelete,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            refetch();
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )    

  const { mutate: studentPutoff, isSuccess: putoffSuccess } = useMutation(
    [endpoints.b2c.student.putoff],
    fetcher.b2c.postStudentPutoff,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            refetch();
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )     

  return { studentInfo, refetch, studentInsert, studentUpdate, appmInsert, appmUpdate, appmDelete, studentDelete, studentPutoff, studentRestore, insertSuccess, updateSuccess, deleteSuccess, putoffSuccess, restoreSuccess, insertSuccessAppm, updateSuccessAppm, deleteSuccessAppm };
};

export default useB2cStudentDetail;
